import { matchPath, useLocation } from 'react-router-dom';

const useRouteMatch = (patterns: readonly string[], end: boolean = true) => {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath({ path: pattern, end }, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
};

export default useRouteMatch;
